import { useRef, useState } from "react";
import { refreshSandboxRefund } from "../api/sandbox-refund";
import { paymentError } from "../api/payments";

export function useRefundStatus(token) {
  const [id, setId] = useState(""), [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const pending = useRef(false);
  async function refresh() {
    if (pending.current) return;
    pending.current = true; setBusy(true); setError(""); setResult(null);
    try { setResult(await refreshSandboxRefund(token, id.trim())); }
    catch (reason) { setError(reason.message?.startsWith("sandbox-") ? "شناسهٔ معتبر بازپرداخت را وارد کنید." : paymentError(reason)); }
    finally { pending.current = false; setBusy(false); }
  }
  return { id, setId, result, busy, error, refresh };
}
